"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constants = require("./constants");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const StyledIcon = _styledComponents.default.svg.withConfig({
  displayName: "StyledIcon",
  componentId: "sc-v4hvps-0"
})(["vertical-align:middle;fill:", ";", " ", ""], _ref => {
  let {
    $color
  } = _ref;
  return $color || 'currentColor';
}, _ref2 => {
  let {
    $background,
    $size
  } = _ref2;
  return $background && `
    overflow: visible;
    background: ${$background};
    border-radius: 50%;
    padding: ${(_constants.SIZES[$size].backgroundSize - _constants.SIZES[$size].iconSize) / 2}px;
  `;
}, _ref3 => {
  let {
    $inline
  } = _ref3;
  return $inline && `
    && {
      margin-top: -0.1em;
    }
  `;
});

/**
## Usage

```js
import { SvgIcon, ArrowRightIcon } from '@farewill/ui'

() => (
  <>
    <ArrowRightIcon />
    <SvgIcon viewBox="0 0 24 24" title="One-off icon">
      <path d="M19 14c0-4.5-3-11-7-11s-7 7-7 11 2.5 7 7 7 7-2.5 7-7z"/>
    </SvgIcon>
  </>
)
```

### How to use this component

Use icons when you need to bridge language gaps or you need to quickly communicate an idea. 

Icons can be effective when they are used to improve visual interest and grab the user’s attention. Use them to visually emphasise the action they represent. 

Make sure icons are clear, simple and accompanied by relevant text. Don’t hide functionality under icons.


#### Using colours

You can apply different colours to icons or their backgrounds.

Make sure the colour you apply to your icon corresponds with accessibility (contrast) guidelines, semantic meaning and visual hierarchy. Use of colour can also help with defining ‘states’ of the icons, such as ‘success’, ‘warning’, ‘error’. Look at colour guidance to determine which colours to use, but don't rely on colour alone to communicate meaning.



#### Size 
The default icon size is 24 x 24px (or 36 x 36px with a background). 
Small: 16 x 16 px 
Large: 32 x 32 px

#### Icons not in the UI library

All icon presets use the `<SvgIcon>` wrapper for sizing and color props. You can use the `<SvgIcon>` component directly for icons that aren't yet in the UI library.

Most icons are compiled directly from the svg assets with the exception of the `<WarningIcon>` component - when the `background` prop is present it uses non-standard optically-adjusted sizing and renders a triangular background.
*/
const SvgIcon = _ref4 => {
  let {
    size = 'M',
    background,
    color,
    inline,
    title,
    children,
    ...props
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(StyledIcon, _extends({
    width: _constants.SIZES[size].iconSize,
    height: _constants.SIZES[size].iconSize,
    "aria-hidden": title ? undefined : true,
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    $background: background,
    $color: color,
    $inline: inline,
    $size: size
  }), title && /*#__PURE__*/_react.default.createElement("title", null, title), children);
};
exports.SvgIcon = SvgIcon;